export default {
  meta: {
    title: '门店-分享页',
    url: '/share/store',
    urlName: '门店分享页',
  },
};
